// extracted by mini-css-extract-plugin
module.exports = {"recoverPassword":"RequestPassword_recoverPassword__2MwVF"};